// @ts-nocheck
/* eslint-disable */

import React from 'react';
import AddEntity from '../../components/CRUD/AddEntity';

const AddPassengersGroup = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  // Configuration for Passengers Group inputs
  const inputs = [
    {
      name: 'name',
      labelKey: 'ArName',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'en_name',
      labelKey: 'EnName',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'description',
      labelKey: 'description',
      type: 'text',
      required: false,
      defaultValue: ''
    },
    {
      name: 'is_default',
      labelKey: 'IsDefaultGroup',
      type: 'checkbox',
      required: false,
      defaultValue: false
    }
  ];

  // Dropdowns configuration
  const dropdowns = [
    {
      name: 'organisations_id',
      labelKey: 'Organisation',
      required: true,
      apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
      apiMethod: 'GET',
      dataPath: 'data.data',
      optionConfig: {
        valueKey: 'id',
        labelKey: 'en_name',
        labelKeyAr: 'ar_name'
      }
    }
  ];

  return (
    <AddEntity
      // ============ PAGE CONFIGURATION ============
      pageTitle="AddPassengersGroup"
      backUrl="/fare-products/passengers-groups"
      
      // ============ API CONFIGURATION ============
      submitApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/passengers_groups`}
      
      // ============ FORM CONFIGURATION ============
      inputs={inputs}
      dropdowns={dropdowns}
      
      // ============ SUCCESS CONFIGURATION ============
      successMessage="PassengersGroupCreatedSuccessfully"

      // ============ PERMISSIONS ============
      subsystemName="PassengersGroups"
      permissionSystem="fares"
    />
  );
};

export default AddPassengersGroup;
